import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { UtenteDelegabile } from '../../../interfaces/delega.interface';
import { DelegheService } from '../../../service/deleghe.service';
import { LoaderService } from '../../../service/loader.service';

export interface NuovaDelegaModalData {
  deleganti: UtenteDelegabile[];
  delegabili: UtenteDelegabile[];
  idAnagraficaTimesheet?: number;
}

@Component({
  selector: 'app-nuova-delega-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './nuova-delega-modal.component.html',
})
export class NuovaDelegaModalComponent {
  form: FormGroup;
  subscriptions = new Subscription();
  errorMessage: string | null = null;

  constructor(
    private fb: FormBuilder,
    private delegheService: DelegheService,
    private loaderService: LoaderService,
    public dialogRef: MatDialogRef<NuovaDelegaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NuovaDelegaModalData,
  ) {
    this.form = this.fb.group({
      matricolaDelegante: [null, Validators.required],
      matricolaDelegato: [null, Validators.required],
    });
  }

  get deleganteUgualeDelegato(): boolean {
    const delegante = this.form.get('matricolaDelegante')?.value;
    const delegato = this.form.get('matricolaDelegato')?.value;
    return delegante && delegato && delegante === delegato;
  }

  confirm(): void {
    if (this.form.invalid || this.deleganteUgualeDelegato) return;
    if (!this.data.idAnagraficaTimesheet) {
      this.errorMessage = 'Nessun periodo timesheet attivo.';
      return;
    }

    this.errorMessage = null;
    this.loaderService.show();

    const payload = {
      idAnagraficaTimesheet: this.data.idAnagraficaTimesheet,
      matricolaDelegante: this.form.value.matricolaDelegante,
      matricolaDelegato: this.form.value.matricolaDelegato,
    };

    this.subscriptions.add(
      this.delegheService.inserisciDelega(payload).subscribe({
        next: () => {
          this.loaderService.hide();
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.loaderService.hide();
          if (err.error && typeof err.error === 'string') {
            this.errorMessage = err.error;
          } else if (err.error?.message) {
            this.errorMessage = err.error.message;
          } else {
            this.errorMessage = 'Errore durante l\'inserimento della delega.';
          }
        },
      })
    );
  }

  reject(): void {
    this.dialogRef.close(false);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
